<template>
  <a-modal :title="form.uid ? '修改发票信息' : '新增发票信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭" destroyOnClose :maskClosable="false" width="1400px"
    :bodyStyle="{ maxHeight: '70vh', overflowY: 'auto' }">
    <a-row :gutter="24">
      <!-- 左侧：表单内容 -->
      <a-col :span="16">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-divider orientation="left">基本信息</a-divider>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="发票类型" prop="type">
                <a-radio-group v-model="form.type" @change="onTypeChange">
                  <a-radio value="1">普通发票</a-radio>
                  <a-radio value="2" disabled>专用发票</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="业务类型" prop="business_type">
                <a-radio-group :disabled="!!form.uid" v-model="form.business_type" @change="onBusinessTypeChange">
                  <a-radio value="1">行程</a-radio>
                  <a-radio value="2">会费</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
              <a-form-model-item label="开票金额" prop="money">
                <a-input-number
                  v-model="form.money"
                  placeholder="请输入开票金额"
                  :min="0"
                  :precision="2"
                  :step="0.01"
                  style="width: 100%"
                >
                  <span slot="addonBefore">¥</span>
                </a-input-number>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="开票状态" prop="invoice_type">
                <a-radio-group v-model="form.invoice_type">
                  <a-radio value="1">待开票</a-radio>
                  <a-radio value="2">已开票</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-model-item label="抬头名称" prop="company_name" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-input v-model="form.company_name" placeholder="请输入抬头名称" />
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
              <a-form-model-item label="关联客户" prop="customer_id">
                <a-input-group compact>
                  <a-select :disabled="!!form.uid" v-model="form.customer_id" placeholder="请输入客户姓名搜索" allowClear show-search
                    :filter-option="false" :not-found-content="customerFetching ? undefined : null"
                    @search="handleCustomerSearch" @focus="getCustomerList" @change="onCustomerChange"
                    style="width: calc(100% - 90px)">
                    <a-spin v-if="customerFetching" slot="notFoundContent" size="small" />
                    <a-select-option v-for="item in customerList" :key="item.customer_id" :value="item.customer_id">
                      {{ item.customer_name }} - {{ item.customer_phone }}
                    </a-select-option>
                  </a-select>
                  <a-button type="link" :disabled="!form.customer_id" @click="viewCustomerDetail" style="width: 90px">
                    <a-icon type="eye" /> 查看档案
                  </a-button>
                </a-input-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.business_type === '1'">
              <a-form-model-item label="关联行程" prop="trip_id">
                <a-select :disabled="!!form.uid || !form.customer_id" v-model="form.trip_id" :placeholder="form.customer_id ? '请输入行程名称搜索' : '请先选择客户'" allowClear
                  show-search  :filter-option="false"
                  :not-found-content="tripFetching ? undefined : null" @search="handleTripSearch" @focus="getTripList">
                  <a-spin v-if="tripFetching" slot="notFoundContent" size="small" />
                  <a-select-option :disabled="!!item.invoiceinfo" v-for="item in tripList" :key="item.trip_id" :value="item.trip_id">
                    {{ item.trip_name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.business_type === '2'">
              <a-form-model-item label="关联会费缴费" prop="member_id">
                <a-select v-model="form.member_id" :placeholder="form.customer_id ? '请选择会员缴费期数' : '请先选择客户'" allowClear
                  show-search :disabled="!!form.uid || !form.customer_id" :filter-option="false"
                  :not-found-content="memberFetching ? undefined : null" @search="handleMemberSearch" @focus="getMemberList">
                  <a-spin v-if="memberFetching" slot="notFoundContent" size="small" />
                  <a-select-option :disabled="!!item.invoiceinfo" v-for="item in memberList" :key="item.member_id" :value="item.member_id">
                    {{ item.vip_key }} - ¥{{ item.pay_price }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="收票邮箱" prop="email" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-input v-model="form.email" placeholder="请输入邮箱（选填）" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="备注" prop="remark" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-textarea v-model="form.remark" placeholder="请输入备注信息(酒店代定多少钱、旅游服务多少钱)" :rows="3" />
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-divider orientation="left">
            详细信息
            <span style="color: #999; font-size: 12px">(专用发票需填写完整信息)</span>
          </a-divider>

          <a-row>
            <a-col :span="12">
              <a-form-model-item label="税号" prop="tin">
                <a-input v-model="form.tin" placeholder="请输入税号(如是个人则填身份证号)" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="注册电话" prop="registration_phone">
                <a-input v-model="form.registration_phone" placeholder="请输入注册电话" />
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-model-item label="注册地址" prop="registered_ddress" :label-col="{ span: 3 }"
                :wrapper-col="{ span: 20 }">
                <a-input v-model="form.registered_ddress" placeholder="请输入注册地址" />
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="12">
              <a-form-model-item label="银行名称" prop="bank_name">
                <a-input v-model="form.bank_name" placeholder="请输入银行名称" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="银行账号" prop="bank_account">
                <a-input v-model="form.bank_account" placeholder="请输入银行账号" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-col>

      <!-- 右侧：发票文件管理 -->
      <a-col :span="8">
        <div style="border-left: 1px solid #e8e8e8; padding-left: 24px; height: 100%">
          <a-divider orientation="left">
            <a-icon type="file-text" /> 发票文件管理
            <a-tag v-if="!form.uid" color="orange" style="margin-left: 8px">需先保存发票</a-tag>
          </a-divider>

          <!-- 新增模式提示 -->
          <a-alert v-if="!form.uid" message="请先保存发票信息后再上传文件" description="文件管理功能需要发票ID，请先填写并保存发票基本信息。" type="info"
            show-icon style="margin-bottom: 20px" />

          <!-- 文件上传区域 -->
          <div style="margin-bottom: 20px">
            <a-upload name="file" :action="baseURL + '/admin/sys/upload'" :headers="{
              Authorization: `Bearer ${token}`,
            }" @change="handleFileChange" :show-upload-list="false" :disabled="!form.uid">
              <a-button type="primary" block :loading="uploadLoading" :disabled="!form.uid">
                <a-icon type="upload" /> 上传发票文件
              </a-button>
            </a-upload>
            <div style="color: #999; margin-top: 8px; font-size: 12px; text-align: center">
              支持 PDF、图片等格式
            </div>
          </div>

          <!-- 已上传文件列表 -->
          <div style="max-height: calc(70vh - 150px); overflow-y: auto"
            :style="{ opacity: !form.uid ? 0.5 : 1, pointerEvents: !form.uid ? 'none' : 'auto' }">
            <a-list :data-source="fileList" :locale="{ emptyText: form.uid ? '暂无文件' : '保存后可上传文件' }" size="small">
              <a-list-item slot="renderItem" slot-scope="file">
                <div style="width: 100%; display: flex; flex-direction: column; gap: 8px">
                  <div style="display: flex; align-items: center; justify-content: space-between">
                    <a :href="file.file" target="_blank"
                      style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                      :title="file.file">
                      <a-icon type="file-pdf" style="color: #1890ff" />
                      {{ getFileName(file.file) }}
                    </a>
                    <a-popconfirm title="确定要删除此文件吗？" ok-text="确定" cancel-text="取消" @confirm="deleteFile(file.id)">
                      <a-button type="link" size="small" danger icon="delete" :loading="file.deleting" />
                    </a-popconfirm>
                  </div>
                  <div style="font-size: 12px; color: #999">
                    上传时间: {{ file.create_time || '未知' }}
                  </div>
                </div>
              </a-list-item>
            </a-list>
          </div>

          <!-- 文件统计 -->
          <div style="margin-top: 16px; padding: 12px; background: #f5f5f5; border-radius: 4px; text-align: center"
            :style="{ opacity: !form.uid ? 0.5 : 1 }">
            <a-statistic title="已上传文件" :value="fileList.length" suffix="个" :value-style="{ fontSize: '18px' }" />
          </div>

          <!-- 发送邮件按钮 -->
          <div style="margin-top: 16px">
            <a-button type="default" block icon="mail" :disabled="!form.uid || !form.email" :loading="sendingEmail"
              @click="sendToEmail">
              发送到收票邮箱
            </a-button>
            <div v-if="form.email" style="color: #999; margin-top: 8px; font-size: 12px; text-align: center">
              将发送至: {{ form.email }}
            </div>
            <div v-else-if="form.uid" style="color: #ff9800; margin-top: 8px; font-size: 12px; text-align: center">
              <a-icon type="exclamation-circle" /> 请先填写收票邮箱
            </div>
          </div>
        </div>
      </a-col>
    </a-row>

    <!-- 客户档案抽屉 -->
    <Customer ref="customer" @ok="getDataList"></Customer>
  </a-modal>
</template>

<script>
import { baseURL } from "@/api/index";
import { mapState } from "vuex";
import { Empty } from "ant-design-vue";
import Customer from "@/components/Customer/index.vue";

export default {
  components: {
    Customer,
  },
  computed: {
    ...mapState(["token"]),
  },
  beforeDestroy() {
    // 清除定时器，防止内存泄漏
    if (this.customerSearchTimer) {
      clearTimeout(this.customerSearchTimer);
    }
    if (this.tripSearchTimer) {
      clearTimeout(this.tripSearchTimer);
    }
    if (this.memberSearchTimer) {
      clearTimeout(this.memberSearchTimer);
    }
  },
  data() {
    return {
      baseURL,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      visible: false,
      confirmLoading: false,
      uploadLoading: false,
      sendingEmail: false,
      customerList: [],
      customerFetching: false,
      customerSearchTimer: null,
      tripList: [],
      tripFetching: false,
      tripSearchTimer: null,
      memberList: [],
      memberFetching: false,
      memberSearchTimer: null,
      fileList: [],
      form: {
        uid: "",
        type: "1",
        business_type: "1",
        invoice_type: "1",
        content: "1",
        company: "1",
        company_name: "",
        money: undefined,
        tin: "",
        registered_ddress: "",
        registration_phone: "",
        bank_name: "",
        bank_account: "",
        email: "",
        remark: "",
        trip_id: undefined,
        customer_id: undefined,
        member_id: undefined,
      },
      rules: {
        type: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: "change",
          },
        ],
        business_type: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "change",
          },
        ],
        invoice_type: [
          {
            required: true,
            message: "请选择开票状态",
            trigger: "change",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入开票金额",
            trigger: "blur",
          },
        ],
        company_name: [
          {
            required: true,
            message: "请输入抬头名称",
            trigger: "blur",
          },
        ],
        tin: [
          {
            required: true,
            message: "请输入税号",
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱格式",
            trigger: "blur",
          },
        ],
        customer_id: [
          {
            required: true,
            message: "请选择关联客户",
            trigger: ["change", "blur"],
          },
        ],
        trip_id: [
          {
            validator: (rule, value, callback) => {
              if (this.form.business_type === '1' && !value) {
                callback(new Error('业务类型为行程时，关联行程必填'));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        member_id: [
          {
            validator: (rule, value, callback) => {
              if (this.form.business_type === '2' && !value) {
                callback(new Error('业务类型为会费时，关联会费缴费必填'));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入备注信息(酒店代定多少钱、旅游服务多少钱)",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 16 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.uid = id;
      this.fileList = [];

      if (id) {
        // 编辑模式，获取发票信息
        this.$http({
          url: "/admin/invoice/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = {
            uid: res.data.uid,
            type: res.data.type || "1",
            business_type: res.data.business_type || "1",
            invoice_type: res.data.invoice_type || "1",
            content: res.data.content || "1",
            company: res.data.company || "1",
            company_name: res.data.company_name || "",
            money: res.data.money || undefined,
            tin: res.data.tin || "",
            registered_ddress: res.data.registered_ddress || "",
            registration_phone: res.data.registration_phone || "",
            bank_name: res.data.bank_name || "",
            bank_account: res.data.bank_account || "",
            email: res.data.email || "",
            remark: res.data.remark || "",
            trip_id: res.data.trip_id || undefined,
            customer_id: res.data.customer_id || undefined,
            member_id: res.data.member_id || undefined,
          };

          // 加载文件列表
          this.fileList = res.data.filesChildren || [];

          // 回显客户信息到下拉列表
          if (res.data.customerinfo) {
            this.customerList = [{
              customer_id: res.data.customerinfo.customer_id,
              customer_name: res.data.customerinfo.customer_name,
              customer_phone: res.data.customerinfo.customer_phone,
            }];
          }

          // 回显行程信息到下拉列表
          if (res.data.tripinfo) {
            this.tripList = [{
              trip_id: res.data.tripinfo.trip_id,
              trip_name: res.data.tripinfo.trip_name,
            }];
          }

          // 回显会员缴费信息到下拉列表
          if (res.data.memberinfo) {
            this.memberList = [{
              member_id: res.data.memberinfo.member_id,
              vip_key: res.data.memberinfo.vip_key,
              pay_price: res.data.memberinfo.pay_price,
              invoiceinfo: res.data.memberinfo.invoiceinfo,
            }];
          }
        });
      } else {
        // 新增模式，重置表单
        this.resetForm();
      }
    },
    resetForm() {
      this.form = {
        uid: "",
        type: "1",
        business_type: "1",
        invoice_type: "1",
        content: "1",
        company: "1",
        company_name: "",
        money: undefined,
        tin: "",
        registered_ddress: "",
        registration_phone: "",
        bank_name: "",
        bank_account: "",
        email: "",
        remark: "",
        trip_id: undefined,
        customer_id: undefined,
        member_id: undefined,
      };
      // 清空下拉列表
      this.customerList = [];
      this.tripList = [];
      this.memberList = [];
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.uid ? "/admin/invoice/update" : "/admin/invoice/create",
            method: "post",
            data: {
              ...this.form,
            },
          })
            .then(() => {
              this.$message.success(this.form.uid ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    onTypeChange(e) {
      // 当发票类型改变时，重新验证税号字段
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField("tin");
      });
    },
    // 业务类型改变时的处理
    onBusinessTypeChange() {
      // 清空行程和会员缴费选择
      this.form.trip_id = undefined;
      this.form.member_id = undefined;
      // 清空列表
      this.tripList = [];
      this.memberList = [];
      // 重新验证相关字段
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField("trip_id");
        this.$refs.ruleForm.validateField("member_id");
      });
      // 如果已选择客户，根据业务类型自动加载相应列表
      if (this.form.customer_id) {
        if (this.form.business_type === '1') {
          this.getTripList();
        } else if (this.form.business_type === '2') {
          this.getMemberList();
        }
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 客户搜索（带防抖）
    handleCustomerSearch(value) {
      // 清除之前的定时器
      if (this.customerSearchTimer) {
        clearTimeout(this.customerSearchTimer);
      }

      // 设置新的定时器，500ms 后执行搜索
      this.customerSearchTimer = setTimeout(() => {
        this.getCustomerList(value);
      }, 500);
    },
    // 获取客户列表
    getCustomerList(searchKeyword = '') {
      this.customerFetching = true;
      this.$http({
        url: "/admin/customer/allCustomerSelect",
        method: "get",
        params: {
          page: 1,
          limit: 20,
          customer_name: searchKeyword, // 模糊搜索客户姓名
        },
      }).then((res) => {
        this.customerList = res.data.result || [];
      }).finally(() => {
        this.customerFetching = false;
      });
    },
    // 客户改变时，清空行程选择和列表，并自动加载行程或会员缴费
    onCustomerChange(value) {
      // 清空行程选择
      this.form.trip_id = undefined;
      // 清空行程列表
      this.tripList = [];
      // 清空会员缴费选择
      this.form.member_id = undefined;
      // 清空会员列表
      this.memberList = [];
      // 如果选择了客户，根据业务类型自动加载相应列表
      if (value) {
        if (this.form.business_type === '1') {
          this.getTripList();
        } else if (this.form.business_type === '2') {
          this.getMemberList();
        }
      }
      //重新校验
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField("customer_id");
      });
    },
    // 行程搜索（带防抖）
    handleTripSearch(value) {
      // 清除之前的定时器
      if (this.tripSearchTimer) {
        clearTimeout(this.tripSearchTimer);
      }

      // 设置新的定时器，500ms 后执行搜索
      this.tripSearchTimer = setTimeout(() => {
        this.getTripList(value);
      }, 500);
    },
    // 获取行程列表（需要先选择客户）
    getTripList(searchKeyword = '') {
      // 如果没有选择客户，不执行查询
      if (!this.form.customer_id) {
        this.$message.warning('请先选择客户');
        return;
      }

      this.tripFetching = true;
      this.$http({
        url: "/admin/trip/page",
        method: "get",
        params: {
          page: 1,
          limit: 20,
          customer_id: this.form.customer_id, // 根据客户ID筛选
          trip_name: searchKeyword, // 模糊搜索行程名称
        },
      }).then((res) => {
        this.tripList = res.data.result || [];
      }).finally(() => {
        this.tripFetching = false;
      });
    },
    // 会员缴费搜索（带防抖）
    handleMemberSearch(value) {
      // 清除之前的定时器
      if (this.memberSearchTimer) {
        clearTimeout(this.memberSearchTimer);
      }

      // 设置新的定时器，500ms 后执行搜索
      this.memberSearchTimer = setTimeout(() => {
        this.getMemberList(value);
      }, 500);
    },
    // 获取会员缴费列表（需要先选择客户）
    getMemberList(searchKeyword = '') {
      // 如果没有选择客户，不执行查询
      if (!this.form.customer_id) {
        this.$message.warning('请先选择客户');
        return;
      }

      this.memberFetching = true;
      this.$http({
        url: "/admin/member/page",
        method: "get",
        params: {
          page: 1,
          limit: 20,
          customer_id: this.form.customer_id, // 根据客户ID筛选
          vip_key: searchKeyword, // 模糊搜索会员期数
        },
      }).then((res) => {
        this.memberList = res.data.result || [];
      }).finally(() => {
        this.memberFetching = false;
      });
    },
    // 文件上传处理
    handleFileChange(info) {
      if (info.file.status === "uploading") {
        this.uploadLoading = true;
        return;
      }
      if (info.file.status === "done") {
        const fileUrl = info.file.response.data.url;
        // 调用接口保存文件记录
        this.$http({
          url: "/admin/invoice/createFile",
          method: "post",
          data: {
            uid: this.form.uid,
            file: fileUrl,
          },
        })
          .then(() => {
            this.$message.success("文件上传成功");
            this.uploadLoading = false;
            // 重新加载文件列表
            this.loadFileList();
          })
          .catch(() => {
            this.uploadLoading = false;
          });
      }
      if (info.file.status === "error") {
        this.uploadLoading = false;
        this.$message.error("文件上传失败");
      }
    },
    // 从文件URL中提取文件名
    getFileName(url) {
      if (!url) return "未知文件";
      const parts = url.split("/");
      const fileName = parts[parts.length - 1];
      // 如果文件名太长，进行截断
      if (fileName.length > 30) {
        return fileName.substring(0, 27) + "...";
      }
      return fileName;
    },
    // 加载文件列表
    loadFileList() {
      this.$http({
        url: "/admin/invoice/info",
        method: "post",
        data: {
          id: this.form.uid,
        },
      }).then((res) => {
        this.fileList = res.data.filesChildren || [];
      });
    },
    // 删除文件
    deleteFile(fileId) {
      // 设置删除loading状态
      const file = this.fileList.find((f) => f.id === fileId);
      if (file) {
        this.$set(file, "deleting", true);
      }

      this.$http({
        url: "/admin/invoice/deleteFile",
        method: "post",
        data: {
          id: fileId,
        },
      })
        .then(() => {
          this.$message.success("删除成功");
          // 重新加载文件列表
          this.loadFileList();
        })
        .catch(() => {
          if (file) {
            this.$set(file, "deleting", false);
          }
        });
    },
    // 发送到收票邮箱
    sendToEmail() {
      if (!this.form.uid) {
        this.$message.warning("请先保存发票信息");
        return;
      }
      if (!this.form.email) {
        this.$message.warning("请先填写收票邮箱");
        return;
      }

      this.$confirm({
        title: "确认发送",
        content: `确定要将发票信息发送到 ${this.form.email} 吗？`,
        okText: "确认发送",
        cancelText: "取消",
        onOk: () => {
          this.sendingEmail = true;
          this.$http({
            url: "/admin/invoice/sendEmail",
            method: "post",
            data: {
              uid: this.form.uid,
            },
          })
            .then(() => {
              this.$message.success("发送成功");
            })
            .catch(() => {
              // 错误已在拦截器中处理
            })
            .finally(() => {
              this.sendingEmail = false;
            });
        },
      });
    },
    // 查看客户档案
    viewCustomerDetail() {
      if (!this.form.customer_id) {
        this.$message.warning("请先选择客户");
        return;
      }
      this.$refs.customer.init({
        customer_id: this.form.customer_id,
      });
    },
    // 列表刷新（客户档案回调）
    getDataList() {
      // 如果需要刷新发票列表，可以通知父组件
      this.$emit("ok");
    },
  },
};
</script>

<style scoped>
.ant-divider-horizontal.ant-divider-with-text-left::before {
  width: 5%;
}
</style>
